import { IconKey,IconTemplate } from '@tabler/icons';

// constant
const icons = {
    IconKey,
    IconTemplate
};
//

const Hr = {

    id: 'authentication',
    title: 'HR Department',
    type: 'group',
    display_id:'W',
    icon: icons.IconTemplate,
    children: [
        {
            id: 'mandate',
            title: 'Employee Onboarding',
            type: 'item',
            display_id:106,
            url: '/Admin/employee_onboard',
            breadcrumbs: false
        },
        {
            id: 'surrender',
            title: 'Add Department',
            type: 'item',
            display_id:113,
            url: '/Admin/add_department',
            breadcrumbs: false
        },
        {
            id: 'user_role',
            title: 'Add User Role',
            type: 'item',
            display_id:121,
            url: '/Admin/add_user_role',
            breadcrumbs: false
        },
    ]
}

export default Hr;
